import React, { useState, useRef, useEffect } from "react";

import {
    Paper,
    Typography,
    IconButton,
    Grid,
    TextField,
    Button,
    Avatar,
    CircularProgress,
    Select,
    MenuItem,
} from "@material-ui/core";
import {
    Row,
    Modal,
    ModalBody,
    Spinner,
    ModalHeader,
    ModalFooter,
} from "reactstrap";
import { Add as AddIcon } from "@material-ui/icons";
import { StyledHeader } from "../../../styles";
import styled from "styled-components";
import Box from "@material-ui/core/Box";
import {
    AlternateEmail,
    Phone,
    Schedule,
    Devices,
    PhoneAndroid,
    Code,
    ClearAll,
} from "@material-ui/icons";
const icons = {
    AlternateEmail,
    Phone,
    Schedule,
    Devices,
    PhoneAndroid,
    Code,
    ClearAll,
};
const noImg = require("./imgProfile.png");
const InfoPaper = styled(Paper)`
    width: 100%;
    border: 1px solid black;
    word-wrap: break-word;
    border-radius: 5px;
`;

const InfoDiv = styled.div`
    display: inline-flex !important;
    margin-top: 30px;
    word-wrap: break-word;
`;
const LabelTypography = styled(Typography)`
    width: 120px !important;
    word-wrap: break-word;
`;
const StyledGridItem = styled(Grid)`
    padding-top: 10px !important;
    padding-bottom: 10px !important;
    padding-right: 10px !important;
    padding-left: 10px !important;
`;
const StyledTextField = styled(TextField)`
    min-width: 300px !important;
    margin-top: 15px !important;
`;

const StyledCircularProgress = styled(CircularProgress)`
    width: 60px !important;
    height: 60px !important;
    margin-bottom: 10px;
    margin-right: 25%;
    margin-left: 25%;
`;
const UpdateStateDiv = styled.div`
    margin: auto;
    width: fit-content;
    margintop: 20px;
`;

const PersonalInfo = (props) => {
    const { contact_no = "" } = props.userProfile;
    const isContactPrefixed =
        contact_no.includes("+44") || contact_no.includes("+353")
            ? true
            : false;
    const [nickNames, setNickNames] = useState(props.nickNames);
    const [editingProfile, setEditing] = useState(false);
    const [prefix, setPrefix] = useState(
        contact_no.includes("+353")
            ? "+353"
            : contact_no.includes("+44")
            ? "+44"
            : "+353"
    );
    const [userProfile, setUserProfile] = useState(props.userProfile);
    const [modalState, setModalState] = useState(false);
    const [initialPassword, setInitialPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [progress, setProgress] = useState(0);
    const [updatingPassword, setUpdatingPasswordState] = useState(false);
    const [profileImgBlob, setProfileImgBlob] = useState(false);
    const fileUploadRef = useRef();
    const { setState } = props;
    const [profileImgError, setprofileImgError] = useState(false);
    const [warningModal, setWarningModal] = useState(false);
    const [warningMessage, setWarningMessage] = useState("");
    const { updateSelectedUserPassword } = props;
    // const loggedInUserProfile  = props.loggedInUserProfile;
    
    useEffect(() => {
        setNickNames(props.nickNames);
    }, [props.nickNames]);
    useEffect(() => {
        const tick = () =>
            setProgress((oldProgress) =>
                oldProgress >= 100 ? 0 : oldProgress + 1
            );

        if (modalState) {
            const timer = setInterval(tick, 20);
            return () => {
                clearInterval(timer);
            };
        }
    }, [props.userProfile, modalState]);

    const renderText = (
        label,
        key,
        userProfile,
        editingProfile,
        setState,
        icon
    ) => {
        if (editingProfile) {
            return (
                <InfoDiv>
                    <LabelTypography variant="title">
                        <b>{label}</b>
                    </LabelTypography>
                    <TextField
                        onChange={(event) => {
                            if (key === "nick_name") {
                                nickNames &&
                                    nickNames.map((e) => {
                                        if (e === event.target.value) {
                                            event.target.value = "";
                                            setWarningModal(true);
                                            setWarningMessage(
                                                "Nick Name already exists!!"
                                            );
                                        } else return null;
                                        return null;
                                    });
                                if (
                                    event.target.value.match(/^[0-9]+$/) !=
                                        null &&
                                    nickNames.includes(event.target.value) ===
                                        false
                                ) {
                                    event.target.value = "";
                                    setWarningModal(true);
                                    setWarningMessage(
                                        "Nick Name should not start with numbers!!"
                                    );
                                }
                                if (
                                    event.target.value.includes(".") === true ||
                                    event.target.value.includes("#") === true ||
                                    event.target.value.includes("$") === true ||
                                    event.target.value.includes("/") === true
                                ) {
                                    event.target.value = "";
                                    setWarningModal(true);
                                    setWarningMessage(
                                        "Nick Name should not include special characters like ., #, $, /!!"
                                    );
                                }
                            }

                            setState(key, event.target.value);
                        }}
                        value={userProfile[key]}
                        style={{ minWidth: "120px", maxWidth: "120px" }}
                    />
                </InfoDiv>
            );
        } else {
            return renderValues(label, userProfile[key], icon);
        }
    };

    const renderValues = (label, value, icon) => {
        const Ico = icons[icon];
        return (
            <InfoDiv>
                <Typography
                    style={{ marginRight: "30px", wordWrap: "break-word" }}
                    variant="title"
                >
                    {" "}
                    <Ico style={{ color: "#0188cc" }} />
                    &nbsp;<b>{label}</b>&nbsp;
                    {typeof value === "object"
                        ? value.map((e, i) => {
                              return (
                                  <span>
                                      {e} {value[i + 1] ? ", " : ""}
                                  </span>
                              );
                          })
                        : value}
                </Typography>
            </InfoDiv>
        );
    };

    return (
        <>
            {" "}
            <Modal isOpen={modalState}>
                <ModalHeader>Change Password</ModalHeader>
                <ModalBody style={{ margin: "auto", width: 310 }}>
                    {!updatingPassword && (
                        <>
                            {" "}
                            <Typography variant="body2">
                                <b>
                                    {" "}
                                    Please Enter Password ( {">"} 6 Characters)
                                </b>
                            </Typography>
                            <StyledTextField
                                value={initialPassword}
                                onChange={(event) =>
                                    setInitialPassword(event.target.value)
                                }
                                label="Please Enter Password"
                            />
                            <StyledTextField
                                value={confirmPassword}
                                onChange={(event) =>
                                    setConfirmPassword(event.target.value)
                                }
                                label="Please Confirm Password"
                            />
                        </>
                    )}
                    {updatingPassword && (
                        <UpdateStateDiv>
                            <StyledCircularProgress
                                variant="determinate"
                                value={progress}
                                color="primary"
                            />
                            <Typography variant="body2">
                                <b>Updating Password</b>
                            </Typography>
                        </UpdateStateDiv>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button
                        onClick={() => {
                            setModalState(false);
                            setInitialPassword("");
                            setConfirmPassword("");
                        }}
                        variant="contained"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={() => {
                            updateSelectedUserPassword(
                                userProfile.uid,
                                initialPassword,
                                (state) => {
                                    setUpdatingPasswordState(state);
                                    if (!updatingPassword) {
                                        setModalState(false);
                                        setInitialPassword("");
                                        setConfirmPassword("");
                                    }
                                }
                            );
                        }}
                        disabled={
                            initialPassword === "" ||
                            initialPassword.length < 7 ||
                            initialPassword !== confirmPassword
                                ? true
                                : false
                        }
                        variant="contained"
                        color="primary"
                    >
                        Submit
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={props.requesting} style={{ maxWidth: "00px" }}>
                <ModalBody>
                    <div style={{ textAlign: "center", paddingTop: "3em" }}>
                        <div
                            style={{
                                background: "white",
                                width: "fit-content",
                                display: "inline-block",
                                padding: "2em",
                            }}
                        >
                            <Spinner
                                style={{
                                    height: 100,
                                    width: 100,
                                    background: "white",
                                    color: "#0188cc",
                                }}
                                color="primary"
                            />
                            <Typography
                                style={{
                                    textAlign: "center",
                                    marginTop: 15,
                                    color: "rgba(0, 0, 0, 0.87)",
                                    fontWeight: "bolder",
                                    fontSize: 20,
                                }}
                                variant="body2"
                            >
                                Processing...
                            </Typography>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
            <InfoPaper style={{ borderWidth: "0.5px", borderColor: "#0188cc" }}>
                <StyledHeader
                    style={{
                        height: "fit-content",
                        width: "100%",
                        backgroundColor: "#0188cc",
                    }}
                >
                    <Box display="flex">
                        <Box flexGrow={1}>
                            <Typography
                                variant="display1"
                                style={{ color: "white" }}
                            >
                                Personal Details
                            </Typography>
                        </Box>
                        <Box style={{ paddingRight: "15px" }}>
                            <Button
                                variant="contained"
                                size="small"
                                style={{
                                    backgroundColor: "#FFA500",
                                    color: "white",
                                    maxHeight: "25px",
                                }}
                                onClick={() => {
                                    setEditing((edit) => !edit);
                                    setUserProfile(props.userProfile);
                                }}
                            >
                                {editingProfile ? "Cancel Edit" : "Edit"}
                            </Button>
                        </Box>
                    </Box>
                </StyledHeader>
                <div style={{ padding: "10px" }}>
                    <Grid
                        container
                        spacing={7}
                        style={{ marginTop: "10px", margin: 12 }}
                    >
                        <StyledGridItem
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                            xl={12}
                            justify="center"
                            alignItems="center"
                        >
                            <Avatar
                                alt={<img src={noImg} alt={"noImg"} />}
                                border={1}
                                src={
                                    profileImgError
                                        ? noImg
                                        : !userProfile.profile_image_url
                                        ? noImg
                                        : userProfile.profile_image_url === ""
                                        ? noImg
                                        : userProfile.profile_image_url
                                }
                                onError={(ev) => {
                                    ev.target.src = noImg;
                                }}
                                style={{
                                    width: "150px",
                                    height: "150px",
                                    margin: "0 auto",
                                    borderStyle: "solid",
                                    borderColor: "#0188cc",
                                    borderRadius: "50%",
                                }}
                            />
                        </StyledGridItem>
                    </Grid>
                    {editingProfile && (
                        <Grid container spacing={7} style={{ margin: 12 }}>
                            <StyledGridItem
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                xl={12}
                                style={{ marginLeft: "30px" }}
                            >
                                <Typography variant="body2">
                                    Add Profile Image
                                </Typography>
                                <input
                                    type="file"
                                    id="file"
                                    ref={fileUploadRef}
                                    accept="image/*"
                                    style={{ display: "none" }}
                                    onChange={(event) => {
                                        if (
                                            event.target.files[0].size > 1000000
                                        ) {
                                            setState(
                                                "fileMaxSizeSnackbar",
                                                true
                                            );
                                        } else {
                                            setUserProfile({
                                                ...userProfile,
                                                profile_image_url: URL.createObjectURL(
                                                    event.target.files[0]
                                                ),
                                            });
                                            setprofileImgError(false);
                                            setProfileImgBlob(
                                                event.target.files[0]
                                            );
                                        }
                                    }}
                                />
                                <IconButton
                                    onClick={() => {
                                        fileUploadRef.current.click();
                                    }}
                                    style={{
                                        margin: "inherit",
                                        color: "green",
                                        border: "1px solid green",
                                    }}
                                >
                                    <AddIcon />
                                </IconButton>
                                <Typography
                                    style={{ margin: "inherit" }}
                                    variant="body2"
                                >
                                    {"(< 1MB)"}
                                </Typography>
                            </StyledGridItem>
                        </Grid>
                    )}
                    <Grid container spacing={7}>
                        <StyledGridItem
                            item
                            xs={2}
                            sm={1}
                            md={1}
                            lg={1}
                            xl={1}
                        ></StyledGridItem>
                        {/* <FormHelperText style={{ color: "red", marginLeft:"11px",marginBottom:"-20px" }}>
                        Nick Name/Report Identifier should contain only 4 characters combination of letters and numbers only (no special characters)
                    </FormHelperText> */}
                        <StyledGridItem
                            item
                            xs={5}
                            sm={5}
                            md={5}
                            lg={5}
                            xl={5}
                            justify="center"
                            alignItems="center"
                        >
                            <Row>
                                {renderText(
                                    "First Name:",
                                    "first_name",
                                    userProfile,
                                    editingProfile,
                                    (key, value) => {
                                        setUserProfile({
                                            ...userProfile,
                                            [key]: value,
                                        });
                                    },
                                    "ClearAll"
                                )}
                            </Row>

                            <Row>
                                {renderText(
                                    "Last Name:",
                                    "last_name",
                                    userProfile,
                                    editingProfile,
                                    (key, value) => {
                                        setUserProfile({
                                            ...userProfile,
                                            [key]: value,
                                        });
                                    },
                                    "ClearAll"
                                )}
                            </Row>
                            <Row>
                                {typeof userProfile.nick_name ===
                                "undefined" ? (
                                    <>
                                        {renderText(
                                            "Nick Name:",
                                            "nick_name",
                                            userProfile,
                                            editingProfile,
                                            (key, value) => {
                                                setUserProfile({
                                                    ...userProfile,
                                                    [key]: value,
                                                });
                                            },
                                            "ClearAll"
                                        )}
                                    </>
                                ) : userProfile.nick_name.length !== 4 ? (
                                    <>
                                        {renderText(
                                            "Nick Name:",
                                            "nick_name",
                                            userProfile,
                                            editingProfile,
                                            (key, value) => {
                                                setUserProfile({
                                                    ...userProfile,
                                                    [key]: value,
                                                });
                                            },
                                            "ClearAll"
                                        )}
                                    </>
                                ) : (
                                    <InfoDiv>
                                        <ClearAll
                                            style={{ color: "#0188cc" }}
                                        />
                                        &nbsp;<b>Nick Name:&nbsp;</b>
                                        {userProfile.nick_name}
                                    </InfoDiv>
                                )}
                            </Row>
                            <Row>
                                <InfoDiv>
                                    <Typography
                                        style={{
                                            maxWidth: 300,
                                        }}
                                        variant="title"
                                    >
                                        <AlternateEmail
                                            style={{ color: "#0188cc" }}
                                        />
                                        &nbsp;<b>Email: &nbsp;</b>
                                        {userProfile.email.split("@")[0]}@
                                        {userProfile.email.split("@")[1]}
                                    </Typography>
                                </InfoDiv>
                            </Row>

                            <Row>
                                {editingProfile? (
                                    <>
                                        <InfoDiv>
                                            <LabelTypography variant="title">
                                                <b>Contact: </b>
                                            </LabelTypography>
                                            {!isContactPrefixed?
                                            <Select
                                                label={"Prefix"}
                                                value={prefix}
                                                onChange={(event) => {
                                                    setPrefix(
                                                        event.target.value
                                                    );
                                                }}
                                            >
                                                <MenuItem value="+353 ">
                                                    +353
                                                </MenuItem>

                                                <MenuItem value="+44 ">
                                                    +44
                                                </MenuItem>
                                            </Select> : ""}
                                            
                                            <TextField
                                                onChange={(event) => {
                                                    setUserProfile({
                                                        ...userProfile,
                                                        contact_no:
                                                            event.target.value,
                                                    });
                                                }}
                                                value={
                                                    userProfile["contact_no"]
                                                }
                                                style={{
                                                    minWidth: "120px",
                                                    maxWidth: "120px",
                                                }}
                                            />
                                        </InfoDiv>
                                        {/* <span
                                            style={{
                                                fontweight: "bold",
                                                color: "red",
                                                width: "100%",
                                                display: "block",
                                            }}
                                        >
                                            Please be aware that once the phone
                                            number is set it cannot be changed
                                            again.
                                        </span> */}
                                    </>
                                ) : (
                                    renderValues(
                                        "Contact :",
                                        userProfile["contact_no"],
                                        "Phone"
                                    )
                                )}
                            </Row>
                        </StyledGridItem>

                        <StyledGridItem
                            item
                            xs={5}
                            sm={6}
                            md={6}
                            lg={6}
                            xl={6}
                            justify="center"
                            alignItems="center"
                        >
                            {typeof userProfile.last_active_device ===
                            "undefined" ? (
                                ""
                            ) : (
                                <>
                                    <Row>
                                        <InfoDiv>
                                            <Typography
                                                style={{
                                                    maxWidth: 300,
                                                }}
                                                variant="title"
                                            >
                                                {" "}
                                                <Schedule
                                                    style={{ color: "#0188cc" }}
                                                />
                                                &nbsp;<b>Last Active: &nbsp;</b>
                                                {userProfile.last_active}
                                            </Typography>
                                        </InfoDiv>
                                    </Row>
                                    <Row>
                                        <InfoDiv>
                                            <Typography
                                                style={{
                                                    maxWidth: 300,
                                                }}
                                                variant="title"
                                            >
                                                {" "}
                                                <Devices
                                                    style={{ color: "#0188cc" }}
                                                />
                                                &nbsp;
                                                <b>Last Device Brand: &nbsp;</b>
                                                {userProfile.last_active_device ===
                                                null
                                                    ? "N/A"
                                                    : userProfile
                                                          .last_active_device
                                                          .brand === null
                                                    ? "N/A"
                                                    : userProfile
                                                          .last_active_device
                                                          .brand}
                                            </Typography>
                                        </InfoDiv>
                                    </Row>
                                    <Row>
                                        <InfoDiv>
                                            <Typography
                                                style={{
                                                    maxWidth: 300,
                                                }}
                                                variant="title"
                                            >
                                                {" "}
                                                <PhoneAndroid
                                                    style={{ color: "#0188cc" }}
                                                />
                                                &nbsp;
                                                <b>Last Device Model: &nbsp;</b>
                                                {userProfile.last_active_device ===
                                                null
                                                    ? "N/A"
                                                    : userProfile
                                                          .last_active_device
                                                          .model === null
                                                    ? "N/A"
                                                    : userProfile
                                                          .last_active_device
                                                          .model}
                                            </Typography>
                                        </InfoDiv>
                                    </Row>
                                    <Row>
                                        <InfoDiv>
                                            <Typography
                                                style={{
                                                    maxWidth: 300,
                                                }}
                                                variant="title"
                                            >
                                                {" "}
                                                <Code
                                                    style={{ color: "#0188cc" }}
                                                />
                                                &nbsp;
                                                <b>Android Version: &nbsp;</b>
                                                {userProfile.last_active_device ===
                                                null
                                                    ? "N/A"
                                                    : userProfile
                                                          .last_active_device
                                                          .android_version ===
                                                      null
                                                    ? "N/A"
                                                    : userProfile
                                                          .last_active_device
                                                          .android_version}
                                            </Typography>
                                        </InfoDiv>
                                    </Row>
                                </>
                            )}
                        </StyledGridItem>

                        <StyledGridItem
                            item
                            xs={2}
                            sm={1}
                            md={1}
                            lg={1}
                            xl={1}
                        ></StyledGridItem>
                        
                        <StyledGridItem
                            item
                            xs={5}
                            sm={5}
                            md={5}
                            lg={5}
                            xl={5}
                            justify="center"
                            alignItems="center"
                            style={{ marginTop: "-20px", marginBottom: "20px" }}
                        >
                            <Row>
                                <InfoDiv>
                                    <Button
                                        disabled={props.canUpdate === false}
                                        onClick={() => setModalState(true)}
                                        variant="contained"
                                        style={{
                                            marginTop: 8,
                                            marginBottom: 5,
                                            backgroundColor: "#0188cc",
                                            color: "white",
                                            marginRight: "55px",
                                        }}
                                    >
                                        Change Password
                                    </Button>
                                </InfoDiv>
                            </Row>
                        </StyledGridItem> 

                        {editingProfile && (
                            <>
                                <StyledGridItem
                                    item
                                    xs={5}
                                    sm={5}
                                    md={5}
                                    lg={5}
                                    xl={5}
                                    justify="center"
                                    alignItems="center"
                                    style={{
                                        marginTop: "-15px",
                                        marginBottom: "20px",
                                    }}
                                >
                                    <Row>
                                        <div
                                            style={{
                                                width: "100%",
                                                float: "right",
                                                marginTop: 30,
                                            }}
                                        >
                                            {typeof userProfile.nick_name ===
                                            "undefined" ? (
                                                <Button
                                                    onClick={() => {
                                                        let prof = userProfile;
                                                        if (
                                                            !isContactPrefixed
                                                        ) {
                                                            prof["contact_no"] =
                                                                prefix +
                                                                prof[
                                                                    "contact_no"
                                                                ];
                                                        }
                                                        props.submitUpdatedProfile(
                                                            prof,
                                                            profileImgBlob
                                                        );
                                                        setEditing(false);
                                                    }}
                                                    variant="raised"
                                                    style={{
                                                        background: "#0188cc",
                                                        color: "white",
                                                        float: "right",
                                                        marginLeft: "18px",
                                                    }}
                                                >
                                                    Save
                                                </Button>
                                            ) : userProfile.nick_name.length ===
                                              4 ? (
                                                <Button
                                                    onClick={() => {
                                                        let prof = userProfile;
                                                        if (
                                                            !isContactPrefixed
                                                        ) {
                                                            prof["contact_no"] =
                                                                prefix +
                                                                prof[
                                                                    "contact_no"
                                                                ];
                                                        }
                                                        props.submitUpdatedProfile(
                                                            prof,
                                                            profileImgBlob
                                                        );
                                                        setEditing(false);
                                                    }}
                                                    variant="contained"
                                                    style={{
                                                        background: "#0188cc",
                                                        color: "white",
                                                        float: "right",
                                                        marginLeft: "18px",
                                                    }}
                                                >
                                                    Save
                                                </Button>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </Row>
                                </StyledGridItem>
                            </>
                        )}
                    </Grid>
                </div>
                <Modal isOpen={warningModal}>
                    <ModalHeader>Warning!!!</ModalHeader>
                    <ModalBody>
                        <b style={{ color: "red" }}>{warningMessage}</b>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            onClick={() => {
                                setWarningModal(false);
                                setWarningMessage("");
                            }}
                        >
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>
            </InfoPaper>
        </>
    );
};

export default PersonalInfo;
